/**
 * Current User identification
 * @module
 */
var _ = require('optimizely-client-fn');

var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function() {
    this.__state = {
      // Randomly assigned visitor ID
      randomId: null,
      visitorIdLocator: null,
    };

    this.on(actionTypes.SET_VISITOR_ID, this.__loadData);
    this.on(actionTypes.DATA_LOADED, this.__setVisitorIdLocator);
  },

  /**
   * Returns randomId if set, else null
   * @returns {string|null}
   */
  getBucketingId: function(): string|null {
    return this.getRandomId();
  },

  /**
   * Return randomId
   * @returns {string|null}
   */
  getRandomId: function(): string|null {
    return this.__state.randomId;
  },

  /**
   * Returns visitorIdLocator if set, else null
   * @returns {VisitorIdLocator|null}
   */
  getVisitorIdLocator: function(): VisitorIdLocator|null {
    return this.__state.visitorIdLocator;
  },

  /**
   * Loads visitor Id
   * @param {VisitorId} payload
   * @private
   */
  __loadData: function(payload:VisitorId) {
    if (__INVARIANT__) {
      require('../utils/invariant').isType('VisitorId', payload);
    }

    _.extend(this.__state, payload);
    this.emitChange();
  },

  /**
   * Loads locator for visitorId, if provided
   * @param {Object} payload
   * @param {ClientData} payload.data
   * @private
   */
  __setVisitorIdLocator: function(payload:any) {
    if (_.isEmpty(payload.data.visitorIdLocator)) {
      return;
    }

    this.__state.visitorIdLocator = payload.data.visitorIdLocator;
    this.emitChange();
  }
};
